"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesHeader = void 0;
var attributes_header_component_1 = require("./attributes-header.component");
Object.defineProperty(exports, "AttributesHeader", { enumerable: true, get: function () { return attributes_header_component_1.AttributesHeader; } });
